export var rewardIds = [
    'currentptsbalance',
    'pointstogo',
    'rewardsthreshold',
    'CurrentBalanceDollars'
];
